// Imports
import AxiosAuth from '@/config/AxiosAuthConfig';
import Csrf from '@/api/Csrf';

// Register User
export const registerUser = async (payload) => {
    const url = '/user/register';

    try {
        // await Csrf.getCookie();

        const { data } = await AxiosAuth.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Reset password
export const resetPasswordEmail = async (payload) => {
    const url = '/user/reset-password-email';

    try {
        // await Csrf.getCookie();

        const { data } = await AxiosAuth.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Verification of register link
export const verifyRegisterLink = async (payload) => {
    const url = 'user/check-register-link';
    try {
        const { data } = await AxiosAuth.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Verification of Forget password link
export const verifyResetPasswordLink = async (payload) => {
    const url = 'user/check-forgot-link';
    try {
        const { data } = await AxiosAuth.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Verification of invite user link
export const verifyInviteUserLink = async (payload) => {
    const url = 'user/check-invite-user-link';
    try {
        const { data } = await AxiosAuth.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Resend confirmation email
export const resendConfirmationEmail = async (payload) => {
    const url = '/user/resend-email';

    try {
        const { data } = await AxiosAuth.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Reset password
export const resetPassword = async (payload) => {
    const url = '/user/reset-password';

    try {
        // await Csrf.getCookie();

        const { data } = await AxiosAuth.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Activate Account
export const activateAccount = async (payload) => {
    const url = '/user/acquainted';

    try {
        const { data } = await AxiosAuth.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Login User
export const loginUser = async (payload) => {
    console.log(payload)
    const url = '/user/login';

    try {
        // await Csrf.getCookie();

        const { data } = await AxiosAuth.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Workspaces
export const getAgencyWorkSpaces = async () => {
    const url = '/user/workspaces';

    try {
        const { data } = await AxiosAuth.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Add Workspace
export const addWorkSpace = async (payload) => {
    const url = '/create-workspace';

    try {
        const { data } = await AxiosAuth.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Logout
export const logout = async () => {
    const url = '/user/logout';

    try {
        const { data } = await AxiosAuth.post(url);
        if (data.code === 200) {
            Csrf.removeCookie();
        }
        return data;
    } catch (e) {
        return e.response;
    }
};

// Check User Existence
export const checkUserExistence = async (uuid, t_uuid) => {
    const url = `/user/check-existence?uuid=${uuid}&t_uuid=${t_uuid}`;

    try {
        const { data } = await AxiosAuth.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Create Password
export const createPassword = async (payload) => {
    const url = '/user/create-password';

    try {
        const { data } = await AxiosAuth.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Set Profile
export const setProfile = async (payload) => {
    const url = '/user/set-profile';

    try {
        const { data } = await AxiosAuth.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Auth User
export const getAuthUser = async () => {
    const url = '/user';

    try {
        const { data } = await AxiosAuth.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
